module.exports = __webpack_public_path__ + "img/qrcode_official.9909943f.png";